import React from 'react';

import Loadable from 'react-loadable';

import { HiddenLoader } from 'src/components/react-loadable';

import { ForgeRepoPullRequestCardsProps } from './repo-pull-request-cards';

const LoadableRepoPullRequestCards = Loadable({
  loading: HiddenLoader,
  loader: () => import('./repo-pull-request-cards'),
});

export const LazyForgeRepoPullRequestCards = ({
  currentUser,
  repository,
  pullRequest,
  workspace,
}: ForgeRepoPullRequestCardsProps) => {
  return (
    <LoadableRepoPullRequestCards
      currentUser={currentUser}
      repository={repository}
      pullRequest={pullRequest}
      workspace={workspace}
    />
  );
};
